import HttpClient from '../services/httpClient';
import debounce from 'debounce';
import algoliasearch from 'algoliasearch/lite';

export default class QuickSearchComponent {
    /**
     * Quick Search Component class
     * @param {*} inputElementSelector search input element's selector
     * @param {int} keyPressMinLength
     * @param {int} resultLimit
     */
    constructor(inputElementSelector = '', keyPressMinLength = 3, resultLimit = 20) {
        this.httpClient_ = new HttpClient();

        this.keyPressMinLength_ = keyPressMinLength;
        this.inputElementSelector_ = inputElementSelector;

        this.searchResultActiveClassName_ = 'search__result--visible';

        this.inputElement_ = document.querySelector(inputElementSelector);

        if (this.inputElement_) {
            this.searchResultElement_ = document.querySelector('.search__result');
            this.searchResultListElement_ = document.querySelector('.search__list');
            this.searchLoadingElement_ = document.querySelector('.search__loading');
            this.searchSubmitElement_ = document.querySelector('.search__button');
            this.searchEndpoint_ = '/bebida/getprodutos.php';
            this.searchEndpointResultLimitItems_ = resultLimit;
            this.searchClient = algoliasearch(
                this.inputElement_.dataset['searchAppId'],
                this.inputElement_.dataset['searchApiKey']
            )
            this.searchIndex = this.searchClient.initIndex(this.inputElement_.dataset['indexName']);
            this.searchRequestOptions = {
                clickAnalytics: true,
                userToken: this.inputElement_.dataset['userId'],
                hitsPerPage: resultLimit,
                attributesToRetrieve: [
                    'name',
                    'categories',
                    'category',
                    'parent',
                    'brand',
                    'sponsored',
                    'in_stock',
                    'url',
                    'image',
                    'priceFormated',
                    'wholesale',
                ],
                attributesToHighlight: [
                    'name',
                    'categories.name',
                    'category.name',
                    'parent.name',
                    'brand.name',
                ],
                facets: [
                    'categories.name',
                    'category.name',
                    'parent.name',
                    'brand.name',
                ],
            };
        }

    }

    /**
     * Load component
     */
    load() {
        if (this.inputElement_) {
            this.bindEventsHandler();
        }
    }

    /**
     * bind pressing key
     */
    bindEventsHandler() {
        const this_ = this;

        this.inputElement_.addEventListener('focus', async (event) => {
            if (this.searchResultListElement_.children.length > 0) {
                this_.searchLoadingElement_.classList.remove('search__loading--visible');
                this_.searchSubmitElement_.classList.remove('search__button--hide');
                this_.searchResultElement_.classList.add(this_.searchResultActiveClassName_);
            } else {
                await this.#searchAlgolia(this.inputElement_)
            }
        });

        this.inputElement_.addEventListener('keydown', debounce(async (event) => {
            await this.#searchAlgolia(event.target);
        }, 500));

        // this.inputElement_.addEventListener('focusout', (event) => {
        //     setTimeout(function () {
        //         this_.searchResultElement_?.classList.remove(this_.searchResultActiveClassName_);
        //     }, 200)
        // });

        this.inputElement_.closest('.js-search').querySelector('.js-searchResultList').addEventListener('click', e => {
            const clickedEl = e?.target.closest('.js-quickSearchItemClicked');
            let eventData = {};
            e.preventDefault();
            if (clickedEl) {
                eventData = {
                    'keyword': clickedEl.dataset.moengageKeyword,
                    'is_result_found': true,
                    'clicked_id': parseInt(clickedEl.dataset.moengageId, 10),
                    'clicked_name': clickedEl.dataset.moengageName,
                    'clicked_type': clickedEl.dataset.moengageType,
                }
                if (clickedEl.dataset.moengageParentId) {
                    eventData['category_id'] = parseInt(clickedEl.dataset.moengageParentId, 10);
                    eventData['category_name'] = clickedEl.dataset.moengageParentName;
                    eventData['subcategory_id'] = parseInt(clickedEl.dataset.moengageCategoryId, 10);
                    eventData['subcategory_name'] = clickedEl.dataset.moengageCategoryName;
                } else if (clickedEl.dataset.moengageCategoryId) {
                    eventData['category_id'] = parseInt(clickedEl.dataset.moengageCategoryId, 10);
                    eventData['category_name'] = clickedEl.dataset.moengageCategoryName;
                }
                if (clickedEl.dataset.moengageBrandId) {
                    eventData['brand_id'] = parseInt(clickedEl.dataset.moengageBrandId, 10);
                    eventData['brand_name'] = clickedEl.dataset.moengageBrandName;
                }
                if ('undefined' !== typeof Moengage) {
                    Moengage.track_event('search_attempt', eventData);
                }
            }
            setTimeout(() => window.location = clickedEl.href, 0);
        });
    }

    async #searchAlgolia(target) {
        if (target.value.length <= this.keyPressMinLength_) {
            this.searchResultElement_.classList.remove(this.searchResultActiveClassName_);
        }

        if (target.value.length >= this.keyPressMinLength_) {
            this.searchLoadingElement_.classList.add('search__loading--visible');
            this.searchSubmitElement_.classList.add('search__button--hide');

            try {
                const queries = [{
                    indexName: 'pages',
                    query: target.value,
                    params: {
                        clickAnalytics: true,
                        analyticsTags: [
                            'home-quick',
                            'PF'
                        ],
                        userToken: this.inputElement_.dataset['userId'],
                    }
                }, {
                    indexName: this.searchIndex.indexName,
                    query: target.value,
                    params: this.searchRequestOptions
                }];

                const searchResult = await this.searchClient.multipleQueries(queries);
                // const searchResult = await this.searchIndex.search(target.value, this.searchRequestOptions);
                this.searchResultElement_.classList.add(this.searchResultActiveClassName_);
                this.#renderAlgoliaResult(searchResult?.results);
            } catch (e) {
                // TODO report failure to circuit breaker ??
                console.log(e);

                const searchResult = await this.httpClient_.get(`${this.searchEndpoint_}?q=${target.value}&limit=${this.searchEndpointResultLimitItems_}`);
                this.searchResultElement_.classList.add(this.searchResultActiveClassName_);
                this.#renderResult(searchResult);
            }

        }
    }

    /**
     * Render search result
     * @param {*} results
     */
    #renderAlgoliaResult(results = []) {
        const [pages, products] = results;
        const categories = [];
        const subcategories = [];
        const brands = [];

        let mainCategories = [];
        let mainBrands = [];

        if (products?.facets["categories.name"]) {
            mainCategories = Object.entries(products?.facets["categories.name"])
                .sort((a, b) => {
                    switch (true) {
                        /** Ordena pela qtd de SKUs na categoria */
                        case b[1] > a[1]:
                            return 1;

                        case b[1] < a[1]:
                            return -1;

                        default:
                            /** Se a qtd de SKUs for igual, ordena pelo nome da categoria */
                            switch (true) {
                                case b[0] > a[0]:
                                    return 1;

                                case b[1] < a[1]:
                                    return -1;

                                default:
                                    return 0;
                            }
                    }
                })
                .map(el => el[0])
                .slice(0, 3)
            ;
        }

        if (products?.facets["brand.name"]) {
            mainBrands = Object.entries(products?.facets["brand.name"])
                .sort((a, b) => {
                    switch (true) {
                        /** Ordena pela qtd de SKUs na marca */
                        case b[1] > a[1]:
                            return 1;

                        case b[1] < a[1]:
                            return -1;

                        default:
                            /** Se a qtd de SKUs for igual, ordena pelo nome da marca */
                            switch (true) {
                                case b[0] > a[0]:
                                    return 1;

                                case b[1] < a[1]:
                                    return -1;

                                default:
                                    return 0;
                            }
                    }
                })
                .map(el => el[0])
                .slice(0, 3)
            ;
        }

        this.searchResultListElement_.innerHTML = '';

        if (pages.nbHits > 0) {
            [...pages.hits].forEach((page, index) => {
                this.searchResultListElement_.innerHTML += `
                    <li class="searchPage__item">
                        <a href="${page.url}"
                           class="searchPage__link"
                           data-insights-object-id="${page?.objectID}"
                           data-insights-position="${index + 1}"
                           data-insights-query-id="${pages.queryID}"
                        >
                            <span class="searchPage__name">
                                ${page._highlightResult['name'].value}
                            </span>
                        </a>
                    </li>
                `;
            });
        }

        if (products.nbHits <= 0) {
            this.searchResultListElement_.innerHTML += `<li class="search__not-found">Nenhum item encontrado</li>`;

            if ('undefined' !== typeof Moengage) {
                Moengage.track_event('search_attempt', {
                    'keyword': products?.query,
                    'is_result_found': false,
                });
            }
        } else {
            [...products.hits].forEach((product) => {
                categories[product.category['name']] = product?.category;
                if (product.subcategory) {
                    subcategories[product.subcategory['name']] = product?.subcategory;
                }
                brands[product.brand['name']] = product?.brand;
            });

            [...mainBrands].forEach((brandName, index) => {
                if (brands[brandName]) {
                    const brand = brands[brandName];

                    this.searchResultListElement_.innerHTML += `
                        <li class="searchBrand__item">
                            <a href="${brand.url}"
                               class="searchBrand__link js-quickSearchItemClicked"
                               data-insights-position="${index + 1}"
                               data-insights-query-id="${products?.queryID}"
                               data-moengage-keyword="${products?.query}"
                               data-moengage-id="${brand.id}"
                               data-moengage-name="${brand.name}"
                               data-moengage-type="brand"
                            >
                                <span class="searchBrand__name">
                                    Marca: ${brand.name}
                                </span>
                            </a>
                        </li>
                    `;
                }
            });

            [...mainCategories].forEach((categoryName, index) => {
                if (categories[categoryName]) {
                    const category = categories[categoryName];

                    this.searchResultListElement_.innerHTML += `
                        <li class="searchCategory__item">
                            <a href="${category.url}"
                               class="searchCategory__link js-quickSearchItemClicked"
                               data-insights-position="${index + 1}"
                               data-insights-query-id="${products?.queryID}"
                               data-moengage-keyword="${products?.query}"
                               data-moengage-id="${category.id}"
                               data-moengage-name="${category.name}"
                               data-moengage-type="category"
                        
                            >
                                <span class="searchCategory__name">
                                    ${category.name}
                                </span>
                            </a>
                        </li>
                    `;
                }
            });

            [...products.hits].forEach((product, index) => {
                let sponsoredClass = '';
                let sponsoredText = '';
                let wholeSaleContent = '';

                if (
                    product.hasOwnProperty('wholesale')
                    && product.wholesale.minQuantity > 0
                    && product.wholesale.price > 0
                ) {
                    wholeSaleContent = `
                 <span class="searchProduct__wholeprice">
                   R$ ${product.wholesale.priceFormated}
                     <small class="searchProduct__wholeprice--small">
                       ${product.wholesale.minQuantity} unds +
                     </small>
                 </span>
               `;
                }
                if (product.sponsored) {
                    sponsoredClass = 'searchProduct__item--sponsored';
                    sponsoredText = `<span class="searchProduct__sponsored">resultado patrocinado</span>`;
                }
                this.searchResultListElement_.innerHTML += `
                    <li class="searchProduct__item ${sponsoredClass}">
                        <a href="${product.url}"
                           class="searchProduct__link js-quickSearchItemClicked"
                           data-insights-object-id="${product?.objectID}"
                           data-insights-position="${index + 1}"
                           data-insights-query-id="${products?.queryID}"
                           data-moengage-keyword="${products?.query}"
                           data-moengage-id="${product.objectID}"
                           data-moengage-name="${product.name}"
                           data-moengage-type="product"
                           data-moengage-category-id="${product.category.id}"
                           data-moengage-category-name="${product.category.name}"
                           data-moengage-parent-id="${product?.parent?.id ?? null}"
                           data-moengage-parent-name="${product?.parent?.name ?? null}"
                           data-moengage-brand-id="${product.brand.id}"
                           data-moengage-brand-name="${product.brand.name}"
                        >
                            ${sponsoredText}
                            <span class="searchProduct__image">
                                <img src="${product.image}"
                                     alt="${product.name.replace(/(<([^>]+)>)/ig, "")}"
                                     class="searchProduct__img"
                                >
                            </span>
                            <span class="searchProduct__info">
                                <span class="searchProduct__name">${product._highlightResult['name'].value}</span>
                    
                                <div class="searchProduct__footer">
                                  <span class="searchProduct__price">
                                        R$ ${product.priceFormated}
                                    <small class="searchProduct__price--small">
                                      por unidade
                                    </small>
                                  </span>
                    
                                  ${wholeSaleContent}
                                </div>
                            </span>
                            <span class="searchProduct__star"></span>
                        </a>
                    </li>
                `;
            });
        }

        this.searchLoadingElement_.classList.remove('search__loading--visible');
        this.searchSubmitElement_.classList.remove('search__button--hide');
    }

    /**
     * Render search result
     * @param {*} items
     */
    #renderResult(items = []) {
        this.searchResultListElement_.innerHTML = '';

        if (items.categories.length <= 0 && items.products.length <= 0) {
            this.searchResultListElement_.innerHTML += `
        <li>Nenhum item encontrado</li>
      `;
        }

        [...items.categories].forEach((category, index) => {
            this.searchResultListElement_.innerHTML += `
<li class="searchCategory__item">
    <a href="${category.url}"
       class="searchCategory__link js-quickSearchItemClicked"
    >
          ${category.name}
        </a>
      </li>
      `;
        });
        [...items.products].forEach((product) => {
            let sponsoredClass = '';
            let sponsoredText = '';
            let wholeSaleContent = '';

            if (product.sponsored) {
                sponsoredClass = 'searchProduct__item--sponsored';
                sponsoredText = `<span class="searchProduct__sponsored">resultado patrocinado</span>`;
            }
            this.searchResultListElement_.innerHTML += `
<li class="searchProduct__item ${sponsoredClass}">
    <a href="${product.url}"
       class="searchProduct__link js-quickSearchItemClicked"
    >
        ${sponsoredText}
        <span class="searchProduct__image">
            <img src="${product.image}"
                 alt="${product.name.replace(/(<([^>]+)>)/ig, "")}"
                 class="searchProduct__img"
            >
        </span>
        <span class="searchProduct__info">
            <span class="searchProduct__name">${product.name}</span>

            <div class="searchProduct__footer">
              <span class="searchProduct__price">
                R$ ${product.priceToFormated}
                <small class="searchProduct__price--small">
                  por unidade
                </small>
              </span>
              ${wholeSaleContent}
            </div>
        </span>
        <span class="searchProduct__star"></span>
        </a>
      </li>
`;
        });

        this.searchLoadingElement_.classList.remove('search__loading--visible');
        this.searchSubmitElement_.classList.remove('search__button--hide');
    }
};
